export default __webpack_public_path__ + "static/media/back.5b0aa7ac.svg";